<template>
  <v-expansion-panel v-model="panel">
    <v-expansion-panel-header class="mt-2">
      Ajustes de inventarios
      <template v-slot:actions>
        <v-btn class="mr-5" @click.native.stop="getFilterData()" icon small>
          <v-icon color="primary">mdi-reload</v-icon>
        </v-btn>
        <v-btn @click="$store.dispatch('deleteWindowByUuid', { uuid: win.uuid })" icon small>
          <v-icon color="error">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-tabs v-model="tab" dark background-color="primary" icons-and-text>
        <v-tabs-slider color="red"></v-tabs-slider>
        <v-tab href="#tab-2" v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']">
          Ajuste de inventario
          <v-icon>mdi-archive-eye</v-icon>
        </v-tab>
        <v-tab href="#tab-7" v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']">
          Solicitud de ajustes
          <v-icon>mdi-table-cog</v-icon>
        </v-tab>
        <v-tab href="#tab-8" v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']">
          Verificacion de ajustes
          <v-icon>mdi-table-edit</v-icon>
        </v-tab>
        <v-tab href="#tab-12" v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']">
          Ajustes de existencias
          <v-icon>mdi-table-plus</v-icon>
        </v-tab>
        <v-tab href="#tab-13" v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']">
          Verificacion de ajustes existencias
          <v-icon>mdi-table-search</v-icon>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" touchless>
        <v-tab-item value="tab-2" v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']">
          <v-card flat class="pa-1 position-relative">
            <v-card-text class="pa-0">
              <SpecialInventoryPhysicalR v-if="SpecialInventoryReport == 1" :keyR="key" :datafilter="filterData" />
              <InventoryPhysicalR v-else :key="key" :datafilter="filterData" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-7" v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']">
          <v-card flat class="pa-1 position-relative">
            <v-card-text class="pa-0">
              <InventoryAdjustmentRequest :key="key" :datafilter="filterData" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-8" v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']">
          <v-card flat class="pa-1 position-relative">
            <v-card-text class="pa-0">
              <InventoryAdjustmentCheck :key="key" :datafilter="filterData" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-12" v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']">
          <v-card flat class="pa-1 position-relative">
            <v-card-text class="pa-0">
              <InventoryAdvancedReport :key="key" :datafilter="filterData" @switchToVerificationTab="switchToVerificationTab" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item value="tab-13" v-if="$store.getters['rolesUser/getArrayCustomRole']([243]) || $store.getters['rolesUser/isAdminOrManager']">
          <v-card flat class="pa-1 position-relative">
            <v-card-text class="pa-0">
              <InventoryAdjustmentCheckAdvanced :key="key" :datafilter="filterData" :preSelectedRequest="selectedRequestForVerification" />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { mapState } from "vuex";
import InventoryPhysicalR from "@/views/inventory/reports/InventoryPhysicalR";
import SpecialInventoryPhysicalR from "../reports/SpecialInventoryPhysicalR.vue";
import InventoryAdjustmentRequest from "../reports/InventoryAdjustmentRequest.vue";
import InventoryAdvancedReport from "../reports/InventoryAdvancedReport.vue";
import InventoryAdjustmentCheck from "../reports/InventoryAdjustmentCheck.vue";
import InventoryAdjustmentCheckAdvanced from "../reports/InventoryAdjustmentCheckAdvanced.vue";

export default {
  name: "InventoryAdjustments",
  components: {
    InventoryPhysicalR,
    SpecialInventoryPhysicalR,
    InventoryAdjustmentRequest,
    InventoryAdvancedReport,
    InventoryAdjustmentCheck,
    InventoryAdjustmentCheckAdvanced,
  },
  props: ["win"],
  data() {
    return {
      panel: 0,
      tab: "tab-2",
      key: 0,
      business: {},
      selectedRequestForVerification: null,
      filterData: {
        Warehouses: [],
        Providers: [],
        Families: [],
        Categories: [],
        SubCategories: [],
        batches: [],
        providers: [],
      },
      SpecialInventoryReport: JSON.parse(localStorage.getItem("user")).SpecialInventoryReport,
    };
  },
  computed: {
    ...mapState("rolesUser", {
      rolesStatus: (state) => state.roles,
    }),
  },
  watch: {
    tab(newTab, oldTab) {
      if (oldTab === "tab-13" && newTab !== "tab-13") {
        this.selectedRequestForVerification = null;
      }
    },
  },
  async mounted() {
    await this.getFilterData();
  },
  methods: {
    switchToVerificationTab(requestData = null) {
      this.tab = "tab-13";

      if (requestData) {
        this.selectedRequestForVerification = requestData;
        this.$nextTick(() => {
          this.key++;
        });
      }
    },
    async getFilterData() {
      try {
        const { businessid = "", branch = "" } = JSON.parse(localStorage.getItem("user"));
        const filtersWh = { business: businessid, branch };

        const [families, categories, subs, warehouses, batches, providers, business] = await Promise.all([
          this.$API.itemtypes.getFamilies(),
          this.$API.itemtypes.getCategories(),
          this.$API.itemtypes.getSubs(),
          this.$API.warehouse.getWarehousesByBusiness(filtersWh),
          this.$API.products.getAllBatch(),
          this.$API.providers.getProvidersHistory(filtersWh),
          this.$API.business.FindOne(businessid),
        ]);

        this.filterData.Families = families.map((fam) => ({ name: fam.name, value: fam.id }));
        this.filterData.Categories = categories.map((cat) => ({ name: cat.name, value: cat.id, parent_id: cat.id_family }));
        this.filterData.SubCategories = subs.map((sub) => ({ name: sub.name, value: sub.id, parent_id: sub.id_cat }));
        this.filterData.Warehouses = warehouses.map((wh) => ({ name: wh.Warehouse, value: wh.ID_Warehouse }));
        this.filterData.batches = batches.map(({ ID_ItemBatch }) => ({ name: ID_ItemBatch, value: ID_ItemBatch }));
        this.filterData.providers = providers.map((prov) => ({ name: prov.ProviderName, value: prov.ID_Provider }));
        this.business = business;
        this.key++;
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    },
  },
};
</script>
